module.exports = __webpack_public_path__ + "media/images/svg/clients/6-3d9148aa71dca2fa4fef2a168182c4f1.svg";